import React from "react";
import styles from "./styles.module.css";
import Image from "next/image";
import { useTranslation } from "next-i18next/pages";
interface Props {
  active: any;
  handleClose: () => void;
}
const Notifaction: React.FC<Props> = ({
  active,
  handleClose
}) => {
  const {
    t
  } = useTranslation('common');
  return <div className={`${styles.fixed} ${active ? styles.active : ''}`}>
      <div className={styles.notificationContainer}>
        <div style={{
        display: 'flex',
        gap: 12,
        alignItems: 'center'
      }}>
          <Image src="/v3/slogo.svg" alt="logo" width={56} height={56} />
          <section>
            <div>{t('Claim your 30-days free trial now!')}</div>
            <div>{t('No credit card require')}</div>
          </section>
        </div>
        <div onClick={handleClose} className={styles.button}>{t('Do not show it again')}</div>
        <div className={styles.closeButton}>
          <Image onClick={handleClose} src="/v3/close.svg" alt="close" width={20} height={20} />
        </div>
      </div>
    </div>;
};
export default Notifaction;